import CoreChartAccountAutomatedMapping from "components/CoreAutomatedMapping"
import React from "react"

const ChartAccountAutomatedMappingReviewScene = (): JSX.Element => {
  return <CoreChartAccountAutomatedMapping />
}

export default ChartAccountAutomatedMappingReviewScene
